var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditModel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 86,
    viewBox: "0 0 99 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_144_772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 0H65C81.5685 0 95 13.4315 95 30V78C95 78 69.5 57.4252 50 40.5C33.621 26.2837 4 0 4 0Z",
    fill: "#217CE8"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_144_772)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.9306 28.1109L57.6111 33.8053C57.5656 34.0135 57.5672 34.2292 57.6157 34.4367C57.6642 34.6442 57.7585 34.8382 57.8916 35.0046C58.0247 35.171 58.1933 35.3055 58.3851 35.3984C58.5769 35.4913 58.787 35.5402 59 35.5415C59.0993 35.5515 59.1994 35.5515 59.2986 35.5415L65.0278 34.222L76.0278 23.2637L69.8889 17.1387L58.9306 28.1109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4863 17.7779L75.3891 13.6807C75.1197 13.4127 74.7552 13.2622 74.3752 13.2622C73.9952 13.2622 73.6306 13.4127 73.3613 13.6807L71.0835 15.9584L77.2154 22.0904L79.4932 19.8126C79.6265 19.6786 79.7321 19.5197 79.8039 19.3449C79.8757 19.1701 79.9123 18.9828 79.9117 18.7938C79.911 18.6048 79.8731 18.4178 79.8001 18.2435C79.7271 18.0692 79.6205 17.911 79.4863 17.7779Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_144_772",
    x: 0,
    y: 0,
    width: 99,
    height: 86,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_144_772"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_144_772",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_144_772"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(56 12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditModel);
export default __webpack_public_path__ + "static/media/edit-model.be40890d4e2996a67f7ae094ef5aebdc.svg";
export { ForwardRef as ReactComponent };